import { Icon, makeStyles } from '@rneui/themed'
import { Image } from 'expo-image'
import React from 'react'
import { Platform, View } from 'react-native'
import { SafeAreaView } from 'react-native-safe-area-context'

interface Props {
  onShare: () => void
}

export function ShareAppView({ onShare }: Props) {
  const styles = useStyles()

  return (
    <SafeAreaView edges={['left', 'right', 'bottom']} style={styles.root}>
      <View style={styles.container}>
        <View style={styles.imageContainer}>
          <Image
            source={require('assets/share_app/share-app.jpg')}
            style={styles.image}
            contentFit="contain"
          />
        </View>
        {Platform.OS === 'web' ? (
          <></>
        ) : (
          <Icon
            type="feather"
            name="upload"
            size={25}
            containerStyle={styles.iconContainer}
            iconStyle={styles.shareIcon}
            onPress={onShare}
          />
        )}
      </View>
    </SafeAreaView>
  )
}

const useStyles = makeStyles(theme => ({
  root: {
    flex: 1,
  },
  container: {
    flex: 1,
  },
  imageContainer: {
    flex: 1,
    margin: 10,
  },
  image: {
    width: '100%',
    height: '100%',
  },
  iconContainer: {
    backgroundColor: theme.colors?.grey6,
    height: 80,
    marginTop: 10,
    justifyContent: 'center',
  },
  shareIcon: {
    color: theme.colors?.blue,
  },
}))
